import { Stack } from '@mantine/core';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { FilterItem } from '../../../../components/filters/filter-item';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { toggleAgentSeriesVisibility } from '../../../../store/process-analysis-store/process-analysis-store.actions';

const getCycleTimeSeries = (t: TFunction) => [
  {
    id: 'agent_cycle_time',
    label: 'Agent',
    description: `Cycle time for ${t('common.work_unit')} with Agent Activity`,
  },
  {
    id: 'non_agent_cycle_time',
    label: 'Non-Agent',
    description: `Cycle time for ${t('common.work_unit')} without Agent Activity`,
  },
];

const getHistogramSeries = getCycleTimeSeries;

export const USAGE_SERIES = [
  {
    id: 'agent_adoption_rate',
    label: 'Adoption Rate',
    description: 'Percentage of eligible users who used an agent in the period.',
  },
  {
    id: 'ai_code_percentage',
    label: 'AI Code %',
    description: 'Weighted average percentage of merged code attributed to AI in the period.',
  },
  {
    id: 'agent_session_count_overtime',
    label: 'Agent Sessions',
    description: 'Number of agent sessions that occurred in the date window.',
  },
  {
    id: 'agent_event_count_overtime',
    label: 'Agent Events',
    description:
      'Number of agent events that occurred in the date window. An event is a single action within the agent session. This can be a user prompt, a tool call, agent response, etc.',
  },
];

export const FiltersContent = () => {
  const { t } = useTranslation();
  const agentVisibleSeries = useProcessAnalysisStore((state) => state.agentVisibleSeries);
  const agentViewMode = useProcessAnalysisStore((state) => state.agentViewMode);
  const agentChartType = useProcessAnalysisStore((state) => state.agentChartType);

  const getSeries = () => {
    if (agentViewMode === 'usage') return USAGE_SERIES;
    if (agentChartType === 'histogram') return getHistogramSeries(t);
    return getCycleTimeSeries(t);
  };

  const series = getSeries();

  return (
    <Stack pb={40}>
      {series.map((item) => (
        <FilterItem
          key={item.id}
          value={item.id}
          label={item.label}
          description={item.description}
          isSelected={agentVisibleSeries[item.id] ?? true}
          showTrends={false}
          selectedCount={Object.values(agentVisibleSeries).filter(Boolean).length}
          onToggle={() => toggleAgentSeriesVisibility(item.id)}
        />
      ))}
    </Stack>
  );
};
